/* --------------------------------------------------------------------------
	Re-implementation of Formstone's swap.js plugin.

	Goal is to avoid importing FormStone core. Side goal is move as much
	work away from load time.

	Missing features are "destroy" and the maxWidth option.

-------------------------------------------------------------------------- */

"use strict";
var $ = jQuery;

var pluginOptions = {
	collapse: true,
	maxWidth: Infinity,
};

$.fn.swap = function swapPlugin(method) {
	// TODO: FormStone core adds some methods, like destroy and getData.
	// AFAICT we don't call them.
	var METHODS = {
		'defaults': setDefaults,
		'activate': activate,
		'deactivate': deactivate,
		'enable': enable,
		'disable': disable,
	};
	
	if (typeof method === "object" || !method) {
		// $().swap(options) or .swap()
		construct.apply(this, arguments);
	} else {
		// $().swap('method', arg1, arg2)
		var args = Array.prototype.slice.call(arguments, 1);
		METHODS[method].apply(this, args);
	}

	return this;
};

/**
 * Updates default plugin options.
 * 
 * @param {object} options 
 */
function setDefaults(options) {
	$.extend(pluginOptions, options);
}

/**
 * Adds listeners and classes. Called bound to a jQuery collection. 
 */
function construct(optionsArgs) {
	var options = {};
	$.extend(options, pluginOptions);
	if (optionsArgs) {
		$.extend(options, optionsArgs);
	}
	
	// Avoid adding duplicate listeners. Also do enable here
	// to avoid repeating the same searches.
	var $elements = this.not('.fs-swap-element');
	$elements.on('click.swap', null, options, onClick)
	$elements.addClass(['fs-swap-element', 'fs-swap-enabled']);

	visitTargets($elements, function (selector, links) {
		var $targets = $(selector);
		if ($targets.length == 0) {
			// Swap element controls element that doesn't exist. Sometimes
			// part of linked set and the other member's target works.
			// Wastes some CPU time.
			console.warn("data-swap-target='" + selector + "' didn't match");
			return;
		}
		var dups = false;
		var key;
		for (key in links) {
			if (dups) {
				// Swap elements control same target, but not as a linked set.
				// Allows mismatched active states between element and target.
				console.warn("data-swap-target='" + selector + "' has multiple controllers");
				break;
			}
			dups = true;
		}
		$targets.addClass(['fs-swap-target', 'fs-swap-enabled']);
	});

	$elements.trigger('enable.swap');
	activate.apply($elements.filter('[data-swap-active]'));
}

/**
 * Old fashioned state kept in the DOM.
 * 
 * @param {DOMElement} el 
 * @returns boolean True if active
 */
function isActive(el) {
	return $(el).hasClass('fs-swap-active');
}

/**
 * Old fashioned state kept in the DOM.
 * 
 * @param {DOMElement} el 
 * @returns boolean True if enabled
 */
 function isEnabled(el) {
	return $(el).hasClass('fs-swap-enabled');
}

/**
 * Finds swapper "buttons" linked together. Usually they share a target,
 * but "don't" have to.
 * 
 * @param {DOMElement} el 
 * @returns jQuery collection of elements linked together.
 */
 function getLinked(el) {
	// data-swap-linked: key that ties buttons controlling same target
	var elements = $(el);
	var linkName = elements.attr('data-swap-linked');
	if (linkName) {
		elements = $('[data-swap-linked="' + linkName + '"]');
	}
	return elements;
}

/**
 * Finds swapper "buttons" groups. Like a radio button group
 * that unchecks the other radio buttons.
 * 
 * @param {DOMElement} el 
 * @returns jQuery collection in the "radio" group or null
 * if not grouped.
 */
function getGroup(el) {
	// data-swap-group: key that ties buttons into a group
	var group = null;
	var groupName = $(el).attr('data-swap-group');
	if (groupName) {
		group = $('[data-swap-group="' + groupName + '"]');
	}
	return group;
}

/**
 * Collects swap target selectors and calls 'callback(selector)'
 * 
 * @param {jQuery}    $linked  Collection of linked buttons
 * @param {function}  callback Called with selector of targets
 */
function visitTargets($linked, callback) {
	var linkedTargets = {};
	var unlinkedId = 0;
	$linked.each(function () {
		var target = $(this).attr('data-swap-target');
		var linked = $(this).attr('data-swap-linked');
		if (!linked) {
			unlinkedId++;
			linked = "unlinked-" + unlinkedId;
		}
		linkedTargets[target] = linkedTargets[target] || {};
		linkedTargets[target][linked] = 1;
	});

	var selector;
	for (selector in linkedTargets) {
		if (linkedTargets.hasOwnProperty(selector)) {
			callback(selector, linkedTargets[selector]);
		}
	}
}

/**
 * Handles clicked swappers. Called bound to a DOMElement as an
 * event handler.
 */
function onClick(event) {
	if (!isEnabled(this)) {
		return;
	}

	var options;
	
	if ($(this).attr('data-swap-options')) {
		var optionJson = $(this).attr('data-swap-options');
		var elementOptions = JSON.parse(optionJson);
		options = {};
		$.extend(options, event.data, elementOptions);
	} else {
		options = event.data;
	}

	if (event && event.preventDefault) {
		event.preventDefault();
		event.stopPropagation();
	}

	if (isActive(this)) {
		if (options.collapse) {
			deactivateElement.apply(this);
		}
	} else {
		activateElement.apply(this);
	}
}

/**
 * Activates a collection. Called bound to a jQuery collection.
 */
function activate() {
	this.each(activateElement);
	return this;
}

/**
 * Activates an element. Called bound to a DOMElement.
 */
function activateElement() {
	var el = this;
	var $group = getGroup(el);
	var $linked = getLinked(el);

	// TODO: Can we optimize this to deactivate all the "other"
	// controls in one shot? The only benefit is combining
	// activate and activateElement.
	if ($group) {
		var $others = $group.not($linked);
		visitTargets($others, function (selector) {
			$(selector).removeClass('fs-swap-active');
		});
		$others.removeClass('fs-swap-active');
		$others.trigger('deactivate.swap');
	}

	visitTargets($linked, function (selector) {
		$(selector).addClass('fs-swap-active');
	});

	$linked.addClass('fs-swap-active');
	$linked.trigger('activate.swap');
}

/**
 * Deactivates a collection. Called bound to a jQuery collection.
 */
function deactivate() {
	this.each(deactivateElement);
	return this;
}

/**
 * Deactivates an element. Called bound to a DOMElement.
 */
function deactivateElement() {
	var el = this;
	var $linked = getLinked(el);

	visitTargets($linked, function (selector) {
		$(selector).removeClass('fs-swap-active');
	});

	$linked.removeClass('fs-swap-active');
	$linked.trigger('deactivate.swap');
}

function enable() {
	this.each(enableElement);
	return this;
}

function enableElement() {
	if (isEnabled(this)) {
		return;
	}

	var $el = $(this);

	$el.addClass('fs-swap-enabled');

	var target = $el.attr('data-swap-target');
	var $target = $(target);
	$target.addClass('fs-swap-enabled');

	$el.trigger('enable.swap');

	if ($el.attr('data-swap-active')) {
		activateElement.apply(this);
	}
}

function disable() {
	this.each(disableElement);
	return this;
}

function disableElement() {
	if (!isEnabled(this)) {
		return;
	}

	if (isActive(this)) {
		deactivate.apply(this);
	}

	var $linked = getLinked(this);
	$linked.removeClass(['fs-swap-enabled']);

	visitTargets($linked, function (selector) {
		$(selector).removeClass('fs-swap-enabled');
	});

	$(this).trigger('disable.swap');
}
